import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-175fd787")
const _hoisted_1 = {
  id: "hero",
  class: "page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode(" Yikes! "),
    /*#__PURE__*/_createElementVNode("span", null, "404")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/",
    "aria-label": "Go to HomePage"
  }, "Back to Saftey"),
  /*#__PURE__*/_createElementVNode("article", null, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h3", {
        "aria-label": "Page Unavailable",
        "item-prop": "title"
      }, " Page Unavailable "),
      /*#__PURE__*/_createElementVNode("h4", { "item-prop": "subheading" })
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" It's just as likely this page "),
      /*#__PURE__*/_createElementVNode("i", null, "should"),
      /*#__PURE__*/_createTextVNode(" exist and I just haven't built it yet. Or it's a typo. Or, I dunno, aliens? ")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}